import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {api} from "../../app/api";

export const fetchPayments = createAsyncThunk(
    'proposal/fetchPayments',
    async () => {
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        const response = await api.get('/user-actions')
        return response.data
    }
)

export const fetchCurrentPayments = createAsyncThunk(
    'payments/fetchCurrentPayments',
    async (id) => {
        const response = await api.get(`/actions/${id}`)
        return response.data
    }
)

const paymentsSlice = createSlice({
    name: 'payment',
    initialState: {
        isLoaded: false,
        payments: [],
        currentPayment: {},
        error: {
            failed: false,
            message: null,
        }
    },
    extraReducers: {
        [fetchPayments.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchPayments.fulfilled]: (state, action) => {
            state.payments = action.payload
            state.isLoaded = true;
        },
        [fetchPayments.rejected]: (state, action) => {
            state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchCurrentPayments.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchCurrentPayments.fulfilled]: (state, action) => {
            state.currentPayment = action.payload
            state.isLoaded = true;
        },
        [fetchCurrentPayments.rejected]: (state, action) => {
            state.isLoaded = false;
            state.error.message = action.payload;
            state.error.failed = true;
        },
    }
})
export default paymentsSlice.reducer